import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as templateApi from '../Api/templateApi';

const TEMPLATE_KEY = 'templates';

export const useTemplates = () => {
	const { data, ...rest } = useQuery({
		queryKey: [TEMPLATE_KEY],
		queryFn: () => templateApi.getTemplates(),
	});
	// Axios returns { data: [...] }
	return { data: Array.isArray(data?.data) ? data.data : [], ...rest };
};

export const useTemplate = (id) => {
	const { data, ...rest } = useQuery({
		queryKey: [TEMPLATE_KEY, id],
		queryFn: () => templateApi.getTemplateById(id),
		enabled: !!id,
	});
	// Axios returns { data: template }
	return { data: data?.data, ...rest };
};

export const useCreateTemplate = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: templateApi.createTemplate,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [TEMPLATE_KEY] });
		},
	});
};

export const useUpdateTemplate = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, templateData }) =>
			templateApi.updateTemplate(id, templateData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [TEMPLATE_KEY] });
		},
	});
};

export const useDeleteTemplate = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id) => templateApi.deleteTemplate(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [TEMPLATE_KEY] });
		},
	});
};

export const useCloneTemplate = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id) => templateApi.cloneTemplate(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [TEMPLATE_KEY] });
		},
	});
};

export const useSystemAdminTemplates = () => {
	const { data, ...rest } = useQuery({
		queryKey: [TEMPLATE_KEY, 'system-admin'],
		queryFn: () => templateApi.getSystemAdminTemplates(),
	});
	// Axios returns { data: [...] }
	return { data: Array.isArray(data?.data) ? data.data : [], ...rest };
};

export const usePurchasedTemplates = () => {
	const { data, ...rest } = useQuery({
		queryKey: [TEMPLATE_KEY, 'purchased'],
		queryFn: () => templateApi.getPurchasedTemplates(),
	});
	// Axios returns { data: [...] }
	return { data: Array.isArray(data?.data) ? data.data : [], ...rest };
};

export const useClaimFreeTemplate = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (templateId) => templateApi.claimFreeTemplate(templateId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [TEMPLATE_KEY] });
		},
	});
};

export const useSendTemplateTestEmail = () =>
	useMutation({
		mutationFn: (data) => templateApi.sendTemplateTestEmail(data),
	});
